<div class="qlist-page">

  <!-- Header -->
  <div class="page-header">
    <div class="header-left">
      <h1>Questionnaires</h1>
      <p class="subtext">{{ questionares.length }} total</p>
    </div>
    <button mat-raised-button color="primary" (click)="openAdd()">
      <mat-icon>add</mat-icon> Add Questionnaire
    </button>
  </div>

  <!-- Error -->
  <div class="alert alert-error" *ngIf="error">
    <mat-icon>error</mat-icon> {{ error }}
    <button class="retry-btn" (click)="load()">Retry</button>
  </div>

  <!-- Search -->
  <div class="search-row">
    <div class="search-box">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        type="text"
        class="search-input"
        placeholder="Search by name, category..."
        [(ngModel)]="searchTerm"
        (input)="applyFilter()"
      />
    </div>
  </div>

  <!-- Loading skeleton -->
  <div class="loading-wrap" *ngIf="loading">
    <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5]"></div>
  </div>

  <!-- Table -->
  <div class="table-wrap" *ngIf="!loading">
    <table mat-table [dataSource]="filteredQuestionares" class="q-table">

      <ng-container matColumnDef="questionareCategory">
        <th mat-header-cell *matHeaderCellDef>Category</th>
        <td mat-cell *matCellDef="let q">{{ q.questionareCategory }}</td>
      </ng-container>

      <ng-container matColumnDef="subCategory">
        <th mat-header-cell *matHeaderCellDef>Subcategory</th>
        <td mat-cell *matCellDef="let q">{{ q.subCategory }}</td>
      </ng-container>

      <ng-container matColumnDef="questionareName">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let q"><strong>{{ q.questionareName }}</strong></td>
      </ng-container>

      <ng-container matColumnDef="questionareDescription">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let q" class="desc-cell">{{ q.questionareDescription }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-col">Actions</th>
        <td mat-cell *matCellDef="let q" class="actions-col">
          <button mat-icon-button class="btn-edit" (click)="openEdit(q)" matTooltip="Edit">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button class="btn-delete" (click)="requestDelete(q.id)" matTooltip="Delete">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- Empty state -->
      <tr class="mat-row" *matNoDataRow>
        <td [colSpan]="displayedColumns.length" class="empty-state">
          <mat-icon>article</mat-icon>
          <p>No questionnaires found.</p>
        </td>
      </tr>

    </table>
  </div>

  <!-- Confirm delete overlay -->
  <div class="overlay" *ngIf="confirmDeleteId !== null">
    <div class="confirm-dialog">
      <mat-icon class="dialog-icon">warning</mat-icon>
      <h3>Delete Questionnaire?</h3>
      <p>This action cannot be undone.</p>
      <div class="dialog-actions">
        <button class="btn-cancel" (click)="cancelDelete()" [disabled]="deleting">Cancel</button>
        <button class="btn-confirm-delete" (click)="confirmDelete()" [disabled]="deleting">
          {{ deleting ? 'Deleting...' : 'Delete' }}
        </button>
      </div>
    </div>
  </div>

</div>
